
export const WEBSITE_URL = "https://freshloop.howincloud.com/public/api";   //for api route uses
export const WEBSITE_BASE_URL = "https://freshloop.howincloud.com/";  //for img purposes


//======================================== API ROUTES ========================================//

//====== Profile routes ======//
export const LOGIN_OTP_USER_URL = WEBSITE_URL + "/login-otp-user";
export const SEND_CUSTOM_OTP_URL = WEBSITE_URL + "/custom-otp-user";
export const VIEW_PROFILE_DATA_URL = WEBSITE_URL + "/view-user-info";
export const USER_UPDATE_USER_INFO_URL = WEBSITE_URL + "/view-user-info";
export const UPDATE_USER_INFO_URL = WEBSITE_URL + "/update-user-info";
export const REGISTER_USER_OTP_URL = WEBSITE_URL + "/register-user-otp";

//====== Subscription routes ======//
export const USER_VIEW_SUBSCRIPTION_URL = WEBSITE_URL + "/get-plans";
export const USER_VIEW_SINGLE_SUBSCRIPTION_URL = WEBSITE_URL + "/get-single-plan";
export const GET_PLAN_FEATURES_URL = WEBSITE_URL + "/get-plan-features";

//====== Address routes ======//
export const GET_USER_ADDRESS_URL = WEBSITE_URL + "/get-user-address";
export const GET_USER_ADDRESSES = WEBSITE_URL + "/get-user-address";
export const GET_ADDRESS_FROM_COORDINATES = WEBSITE_URL + "/coordinate-to-address";
export const DELETE_ADDRESS_URL = WEBSITE_URL + "/delete-user-address";
export const SET_DEFAULT_ADDRESS_URL = WEBSITE_URL + "/set-default-address";
export const SAVE_ADDRESS_URL = WEBSITE_URL + "/save-user-addresss";

//====== Wallet routes ======//
export const GET_USER_WALLET_TRANSACTIONS_URL = WEBSITE_URL + "/view-wallet";
export const REFERAL_DETAILS_URL = WEBSITE_URL + "/refer-earn";
export const WALLET_TOPUP_URL = WEBSITE_URL + "/request-for-topup";

//====== Category routes ======//
export const GET_ALL_MAIN_CATEGORIES_URL = WEBSITE_URL + "/all-main-categories";
export const GET_ALL_SINGLE_CATEGORIES_URL = WEBSITE_URL + "/get-single-category";
export const GET_ALL_CATEGORIES_URL = WEBSITE_URL + "/all-categories";
export const GET_ALL_SINGLE_SUB_CATEGORIES_URL = WEBSITE_URL + "/get-single-subcategory";
export const GET_ALL_SINGLE_SUB_ITEMS_URL = WEBSITE_URL + "/get-single-subItems";

//====== Cart & Order routes ======//
export const GET_MY_ORDER_URL = WEBSITE_URL + "/view-user-order";
export const GET_CALCULATE_BRANCH_MAX_DISTANCE = WEBSITE_URL + "/calculate-branch-distance";
export const GET_BRANCH_INFO_AND_OPERATIONAL_STATUS_URL = WEBSITE_URL + "/branch-oparational-status";
export const LIST_USER_VOUCHER_URL = WEBSITE_URL + "/list-user-vouchers";
export const APPLY_VOUCHER_URL = WEBSITE_URL + "/calculate-coupon-discount";
export const VIEW_TIMESLOTS_URL = WEBSITE_URL + "/view-time-slots";
export const VIEW_ALL_TIMESLOTS_URL = WEBSITE_URL + "/view-all-time-slots";
export const PLACE_ORDER_URL = WEBSITE_URL + "/place-order";
export const CHECK_CART_ITEMS_AVAILABILITY_URL = WEBSITE_URL + "/check-cart-items-availability";
export const CANCEL_ORDER_URL = WEBSITE_URL + "/cancel-order";

//====== Banner routes ======//
export const GET_HOME_BANNERS_URL = WEBSITE_URL + "/get-home-banners";
export const GET_SINGLE_BANNER_ITEM_URL = WEBSITE_URL + "/get-single-banner-items";

//====== Slider routes ======//
export const GET_HOME_SLIDERS_URL = WEBSITE_URL + "/get-home-sliders";
export const GET_SINGLE_SLIDER_ITEM_URL = WEBSITE_URL + "/get-single-slider-items";

//====== Item & Subitem routes ======//
export const GET_ALL_ITEMS_POPULAR_URL = WEBSITE_URL + "/get-all-items-popular";
export const GET_POPULAR_ITEMS_URL = WEBSITE_URL + "/get-popular-items";
export const GET_SINGLE_ITEM_URL = WEBSITE_URL + "/view-single-Item";
export const RATE_OUR_ITEM_URL = WEBSITE_URL + "/review-delivery";
export const VIEW_STORIES_URL = WEBSITE_URL + "/view-stories";
export const UPDATE_STORIES_VIEW_URL = WEBSITE_URL + "/update-stories-view";
export const GET_SEARCH_SINGLE_ITEMS_URL = WEBSITE_URL + "/search-singleitems";


//====== Plan Purchase ======//
export const PURCHASE_PLAN = WEBSITE_URL + "/plan-purchase";
export const USER_PLAN_URL = WEBSITE_URL + "/user-plans";



